/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __awaiter, __generator } from "tslib";
/**
 * Wraps an async task with a performance timer. Only logs to console in development.
 */
export function wrapWithTimer(taskDescription, task) {
    return __awaiter(this, void 0, void 0, function () {
        var shouldMeasure, start, time;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    shouldMeasure = NODE_ENV === "development" && typeof performance !== "undefined";
                    /* eslint-disable no-console */
                    if (shouldMeasure) {
                        start = performance.now();
                        console.info("Started '" + taskDescription + "'...");
                    }
                    return [4 /*yield*/, task()];
                case 1:
                    _a.sent();
                    if (shouldMeasure) {
                        time = Math.round(performance.now() - start);
                        console.info("Finished '" + taskDescription + "' in " + time + "ms");
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=loaderUtils.js.map